module.exports = __webpack_public_path__ + "static/media/est-kerrisdale-vancouver.ac701883.png";